import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/dashboard/components/CollectorAvatars/wrapper.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/components/NFTMintCard/NFTImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/components/NFTMintCard/NFTMintBtn/states/ConnectWalletOrMint.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/packages/nextjs/app/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage"] */ "/vercel/path0/packages/nextjs/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/components/ui/button.tsx");
